import React, { useEffect, useState, useRef } from 'react';
const UNLOCK_SECONDS = 60;
export function VideoIntroPopup() {
  const [isVisible, setIsVisible] = useState(true);
  const [canClose, setCanClose] = useState(false);
  const [timeLeft, setTimeLeft] = useState(UNLOCK_SECONDS);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  useEffect(() => {
    // Start 60-second countdown immediately
    timerRef.current = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timerRef.current!);
          setCanClose(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };
  if (!isVisible) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4" data-id="element-346">
      <div className="relative w-full max-w-4xl" data-id="element-347">
        {/* Header */}
        <div className="bg-black rounded-t-xl px-5 py-3 flex items-center justify-between" data-id="element-348">
          <p className="text-white font-bold text-sm md:text-base" data-id="element-349">
            🎬 Mirá este video antes de continuar
          </p>
          {!canClose ? <div className="flex items-center gap-2 bg-red-600 text-white text-sm font-black px-3 py-1.5 rounded-lg" data-id="element-350">
              <span className="animate-pulse" data-id="element-351">⏳</span>
              <span data-id="element-352">Podés cerrar en {formatTime(timeLeft)}</span>
            </div> : <button onClick={() => setIsVisible(false)} className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white text-sm font-black px-4 py-1.5 rounded-lg transition-colors" data-id="element-353">
              ✅ Continuar a la página
            </button>}
        </div>

        {/* Video */}
        <div className="relative w-full bg-black rounded-b-xl overflow-hidden" style={{
        paddingTop: '56.25%'
      }} data-id="element-354">
          <iframe ref={iframeRef} src="https://player.vimeo.com/video/1169204638?badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&muted=0" className="absolute inset-0 w-full h-full" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" referrerPolicy="strict-origin-when-cross-origin" title="prueba 2- posible final" data-id="element-355" />
        </div>

        {/* Bottom bar */}
        {!canClose && <div className="bg-gray-900 rounded-b-xl px-5 py-2 text-center" data-id="element-356">
            <p className="text-gray-400 text-xs" data-id="element-357">
              Podés cerrar el video en {formatTime(timeLeft)} — ¡vale la pena
              verlo completo!
            </p>
          </div>}
      </div>
    </div>;
}